import { useSettingsByPath } from 'pos-client/hooks/useSettings.tsx';
import { today } from 'pos-client/utils/dayjs.ts';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useConflictLanes = (
  serviceLocationId: string,
  timeZone: string,
  serviceType: string
) => {
  const start = today.tz(timeZone ?? undefined);
  const end = start.add(14, 'day');

  const { first: conflictSetting } = useSettingsByPath({
    path: 'Features>EnableConflictLanes',
  });

  const conflictEnabled = conflictSetting?.value === 'true';

  const { data: laneConflicts, isLoading: laneConflictsLoading } =
    trpc.getConflictLanes.useQuery(
      {
        serviceLocationId,
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD'),
        serviceType: serviceType.toLowerCase() as 'static' | 'mobile',
      },
      {
        enabled:
          conflictEnabled &&
          !!serviceLocationId &&
          !!timeZone &&
          !!serviceType &&
          serviceType.toLowerCase() === 'static',
      }
    );

  return { laneConflicts, laneConflictsLoading };
};
